export default __webpack_public_path__ + "static/media/zalo.0dae1908.svg";